import type { OfferPackage } from 'BrokerTsLib/src/dtos'
import { createContext, useContext } from 'react'
import { useCalculateOffers, useGetOffers } from '../hooks/useOffer'
import type { BaseOffersProviderProps, IOffersContext } from './OffersProvider'
import { BaseOfferProviderDefaults, OffersProvider } from './OffersProvider'

export const offersTravelContext = createContext<IOffersContext<OfferPackage>>(BaseOfferProviderDefaults as any)

export function OffersTravelProvider(props: BaseOffersProviderProps) {
  return (
    <OffersProvider
      signalRCalcFinishedEventName='TravelCalcFinished'
      useGetOffers={useGetOffers}
      useCalculateOffers={useCalculateOffers}
      context={offersTravelContext as any}
      defaults={BaseOfferProviderDefaults}
    >
      {props.children}
    </OffersProvider >
  )
}

export const useOffersTravelContext = () => {
  const context = useContext(offersTravelContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useOffersTravelContext must be used within a OffersTravelProvider!')
  }

  return context
}